import { useTransitionState } from 'shared/domains/common-ui';
import { Container } from './styled';
export function AnimateHeightContainer(props) {
    const { children, isOpen } = props;
    const state = useTransitionState(isOpen, 200);
    return <Container $isOpen={state === 'visible'}>{state !== 'hidden' && children}</Container>;
}
